import React from "react";

interface FixedStorageDescriptionProps {
  description: string;
}

const FixedStorageDescription: React.FC<FixedStorageDescriptionProps> = ({
  description,
}) => {
  const [firstStorage, ...remainingStorage] = description.split(" and ");

  return (
    <span className="leading-none">
      <span className="whitespace-nowrap leading-none">Fixed at {firstStorage}</span>
      {remainingStorage.map((storage, index) => (
        <React.Fragment key={`${storage}-${index}`}>
          {" and "}
          <span className="whitespace-nowrap leading-none">{storage}</span>
        </React.Fragment>
      ))}
    </span>
  );
};

export default FixedStorageDescription;
